export default () => ({
	type: 'MODIFY_ALERTS',
	payload: []
})
